<template lang="pug">
  b-modal#addSubAccount(
    ref="addSubAccount"
    :title="$t('ui.add_sub_account')"
    centered
    no-fade
    no-close-on-backdrop
    :busy="loading"
    size="md"
    @ok="done"
    @show="reset"
    @shown="shown"
  )
    b-form(novalidate :disabled="!submission.success" @submit.stop.prevent="submit")
      //- b-row.mb-2
      .form-group
        label {{ $t("ui.account_id") }}
        b-input-group.input-group-sm(:prepend="$store.getters.accountID.toUpperCase() + '@'")
          b-form-input(
            type="text"
            ref="account_id"
            :class="{ 'is-invalid': $v.account_id.$dirty == true && $v.account_id.$error == true, 'is-valid': $v.account_id.$dirty == true && $v.account_id.$error == false }"
            :placeholder="$t('ui.account_id')"
            v-model.trim.lazy="$v.account_id.$model"
            :maxLength="$v.account_id.$params.maxLength.max"
            :disabled="loading"
            size="sm"
            autocomplete="new-password"
          )
          ValidateResult(:value="$v.account_id" :name="$t('ui.account_id')")
      .form-group
        label {{ $t("ui.password") }}
        b-input-group.input-group-sm
          DebounceInput(
            :type=" (isPWShown) ? 'password' : 'text'"
            ref="password"
            :dirty="$v.password.$dirty"
            :error="$v.password.$error"
            :placeholder='$t("ui.password")'
            v-model.trim.lazy="$v.password.$model"
            :maxLength="$v.password.$params.maxLength.max"
            :disabled="loading"
          )
          .input-group-append(style="cursor: pointer;")
            b-button.btn.btn-outline-secondary.btn-sm(:pressed.sync="isPWShown" style="border-top-right-radius: 3px;border-bottom-right-radius: 3px;")
              i.fa(:class=" (isPWShown) ? 'icon-eye-open fa-eye' : 'icon-eye-close fa-eye-slash'")
          ValidateResult(:value="$v.password" :name="$t('ui.password')")
      .form-group
        label {{ $t("ui.confirm_password") }}
        b-input-group.input-group-sm
          DebounceInput(
            :type=" (isCPWShown) ? 'password' : 'text'"
            ref="confirm_password"
            :dirty="$v.confirm_password.$dirty"
            :error="$v.confirm_password.$error"
            :placeholder='$t("ui.confirm_password")'
            v-model.trim.lazy="$v.confirm_password.$model"
            :disabled="loading"
          )
          .input-group-append(style="cursor: pointer;")
            b-button.btn.btn-outline-secondary.btn-sm(:pressed.sync="isCPWShown" style="border-top-right-radius: 3px;border-bottom-right-radius: 3px;")
              i.fa(:class=" (isCPWShown) ? 'icon-eye-open fa-eye' : 'icon-eye-close fa-eye-slash'")
          ValidateResult(:value="$v.confirm_password" :name="$t('ui.confirm_password')" :name2="$t('ui.password')")
      .form-group
        label {{ $t("ui.contact_phone") }}
        DebounceInput(
          type="text"
          ref="contact_phone"
          :dirty="$v.contact_phone.$dirty"
          :error="$v.contact_phone.$error"
          :placeholder='$t("ui.contact_phone")'
          v-model.trim.lazy="$v.contact_phone.$model"
          :maxLength="$v.contact_phone.$params.maxLength.max"
          :disabled="loading"
        )
        ValidateResult(:value="$v.contact_phone" :name="$t('ui.contact_phone')")
      //- .form-group
      //-   label {{ $t("ui.contact_email") }}
      //-   DebounceInput(
      //-     type="text"
      //-     ref="contact_email"
      //-     :dirty="$v.contact_email.$dirty"
      //-     :error="$v.contact_email.$error"
      //-     :placeholder='$t("ui.contact_email")'
      //-     v-model.trim.lazy="$v.contact_email.$model"
      //-     :disabled="loading"
      //-   )
      //-   ValidateResult(:value="$v.contact_email" :name="$t('ui.contact_email')")
      .form-group
        label {{ $t('ui.authority_option') }}
        b-form-checkbox-group(
          ref="authority_option"
          v-model="authority_option"
          :disabled="loading"
          :options="authorityList"
        )
      .form-group
        b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, minValue, maxValue, minLength, maxLength, email, numeric, sameAs, helpers, alphaNum } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

const containAlphaNum = helpers.regex("containAlphaNum", /^(?=.*\d)(?=.*[a-zA-Z])/);

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  data() {
    return {
      isPWShown: true,
      isCPWShown: true,
      loading: false,
      account_id: "",
      password: "",
      confirm_password: "",
      contact_phone: "",
      contact_email: "",
      authority_option: [],
      submission: {
        success: true,
        status: ""
      }
    }
  },
  validations: {
    account_id: {
      required,
      alphaNum,
      minLength: minLength(2),
      maxLength: maxLength(20)
    },
    password: {
      required,
      valid: function(value) {
        return this.$helpers.passwordFormat(value);
      },
      minLength: minLength(8),
      maxLength: maxLength(50)
    },
    confirm_password: {
      required,
      sameAs: sameAs('password')
    },
    contact_email: {
      email,
      maxLength: maxLength(100)
    },
    contact_phone: {
      minLength: minLength(9),
      maxLength: maxLength(50)
    }
  },
  computed: {
    authorityList: function() {
      let list = this.$store.getters.accessOptions
      let result = []
      list.forEach( value => {
        result.push({value:value, text:this.$t("ui." + value)})
      })
      return result
    }
  },
  mounted () {},
  methods: {
    done: function(evt) {
      evt.preventDefault()
      this.submit()
    },
    submit: function() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true
        this.$swal({
          title: this.$t("ui.status"),
          text: this.$t("message.create_sub_account_confirm"),
          type: "warning",
          showCancelButton: true,
          allowOutsideClick: false
        }).then(result => {
          if (result.value) {
            this.addSubAccount()
          } else if (
            // Read more about handling dismissals
            result.dismiss === 'cancel'
          ) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.cancel"),
              text: this.$t("message.create_sub_account_cancel"),
              type: "error",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        });
      }
    },
    addSubAccount: function() {
      // let new_login_id = this.$store.getters.accountID + '@' + this.account_id
      let new_login_id = this.account_id
      let new_password = this.password
      let authority_option = this.authority_option
      let full_name = null //this.full_name
      let contact_email = this.contact_email
      let contact_phone = this.contact_phone
      this.$store
        .dispatch("user/addSubAccount", { new_login_id, new_password, authority_option, full_name, contact_email, contact_phone })
        .then(response => {
          this.submission.success = response.success
          this.submission.status = response.errorTag
          if(this.submission.success == true) {
            this.loading = false
            this.$swal({
              title: this.$t("title.account_creation"),
              html: "<div>" + this.$t("message.create_sub_account_success") + "</div><br/>" +
                    "<div id='text-to-copy'>" + this.$t("ui.account_id") + ": <strong>" + this.$store.getters.accountID + '@' + this.account_id + "</strong><br/>" +
                    this.$t("ui.password") + ": <strong>" + new_password + "</strong></div>",
              type: "success",
              showCancelButton: true,
              confirmButtonText: this.$t("ui.copy"),
              cancelButtonText: this.$t("ui.ok"),
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm.value) {
                this.$helpers.selectText('text-to-copy')
                try {
                  var successful = document.execCommand('copy')
                  this.$swal(this.$t("ui.succeed"), this.$t("message.copy_success"), "success");
                  this.cancel()
                } catch (ex) {
                  this.$swal(this.$t("ui.fail"), this.$t("message.copy_failed"), "error");
                }
              } else if (
                // Read more about handling dismissals
                isConfirm.dismiss === 'cancel'
              ) {
                this.cancel()
              }
            });
          }
        })
        .catch(response => {
          console.log("Failed:updateAccountProfile", response)
          this.loading = false;
          this.submission.success = response.success
          this.submission.status = this.$t("message." + response.errorTag)
        });
    },
    reset: function() {
      this.submission.success = true
      this.submission.status = ""
      this.account_id = ""
      this.password = ""
      this.confirm_password = ""
      this.contact_phone = ""
      this.contact_email = ""
      this.authority_option = []
    },
    shown: function() {
      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    cancel: function() {
      console.log('here');
      this.$emit("clicked")
      this.$refs.addSubAccount.hide();
    }
  }
}
</script>